import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@shared/pipes/pipes.module';
import { AllowedForAppFlavourDirective } from './allowed-for-app-flavour.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { FeatureCheckDirective } from './feature-check.directive';
import { AuthenticatedCheckDirective } from './authenticated-check.directive';

@NgModule({
    declarations: [
        AllowedForAppFlavourDirective,
        NumbersOnlyDirective,
        FeatureCheckDirective,
        AuthenticatedCheckDirective
    ],
    imports: [CommonModule],
    exports: [
        AllowedForAppFlavourDirective,
        NumbersOnlyDirective,
        FeatureCheckDirective,
        AuthenticatedCheckDirective
    ],
    providers: [],
})
export class DirectivesModule {}